import { Currency, UserData } from '../types';

export type ViewUsersResponse = {
  result: UserData[] | UserData;
};

export const currencyShortNameWithSymbolMapping: Record<Currency, string> = {
  EUR: 'symbol-eur-short',
  USD: 'symbol-usd-short',
};

export const currencyFullNameMapping: Record<Currency, string> = {
  EUR: 'eur',
  USD: 'usd',
};

export const currencyPowerBiMapping: Record<Currency, string> = {
  EUR: 'Euro',
  USD: 'Dollar',
};
